import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { FaPlay, FaLock, FaCheckCircle, FaArrowLeft, FaList } from 'react-icons/fa';
import { BsCollectionPlayFill } from 'react-icons/bs';
import { HiSparkles } from 'react-icons/hi';
import NavbarSection from './NavbarSection';

const APC_VIDEOS = [
  { title: "Opening Video", url: "https://youtu.be/hV4xIv821nA" },
  { title: "Why to Appoint the PC", url: "https://youtu.be/D0-mU13A1D8" },
  { title: "Qualities of Super Efficient PC And How/From Where To Hire Her", url: "https://youtu.be/6V0Mr0EiB9Q" },
  { title: "Features of Good Collection Call - Part A", url: "https://youtu.be/UU7fxN3TLJg" },
  { title: "Features of Good Collection Call - Part B", url: "https://youtu.be/GMhJ51E0SMI" },
  { title: "Customer Excuses Index", url: "https://youtu.be/zOjWzspgKFM" },
  { title: "At What Time and from which no. to Call to the Customers", url: "https://youtu.be/DFjo_pCRxRc" },
  { title: "Actually - When Does the Payment Process Starts", url: "https://youtu.be/Mu3jOrlwiBY" },
  { title: "How To Create Proof of Delivery", url: "https://youtu.be/ssQZFuuKFhY" },
  { title: "Video 10 - At What Time and from which no. to Call to the Customers", url: "https://youtu.be/vRt1_Wlsdzs" },
  { title: "How to Open The first Call", url: "https://youtu.be/haxAEbKCQg4" },
  { title: "Video 12 - Getting All OK - Before the Call", url: "https://youtu.be/hUu-pJKex5g" },
  { title: "Customer Excuses 1 and 2", url: "https://youtu.be/2pVOk3yCCJA" },
  { title: "Customer Excuses 3, 4 and 5", url: "https://youtu.be/MZZDtKcR55g" },
  { title: "Customer Excuses 6 and 7", url: "https://youtu.be/XX4cqtZR2VY" },
  { title: "Customer Excuses 8 and 9", url: "https://youtu.be/kOvuAaXezEo" },
  { title: "Customer Excuses 10, 11, 12 and 13", url: "https://youtu.be/3k6aYVcUR7M" },
  { title: "Customer Excuses 14 and 15", url: "https://youtu.be/2IZYGqHE-RI" },
  { title: "Customer Excuse No. 16", url: "https://youtu.be/TFryl8pv7b4" },
  { title: "Customer Excuse No 17 and 18", url: "https://youtu.be/WPmp4qt2l7A" },
  { title: "Connecting the Dots......", url: "https://youtu.be/yZX75U85Q84" },
  { title: "Don't Write Off Your Debts EVER!!", url: "https://youtu.be/MqtdfqBuvgo" },
  { title: "Training of Recovery Team - Video 1", url: "https://youtu.be/0c7_ZAWO1Og" },
  { title: "Training of Recovery Team - Video 2", url: "https://youtu.be/aXSM5Gi7Yj8" },
  { title: "Training of Recovery Team - Video 3", url: "https://youtu.be/QpkcoGhm3PY" },
  { title: "7 Tactics What To Do When Customer Does not Picks up your Call", url: "https://youtu.be/x4iIJGhC3ok" },
  { title: "Video For Advance Followup Sequence", url: "https://youtu.be/oUQeTAe6oSI" },
  { title: "Closing Video", url: "https://youtu.be/a-76T8fmMKk" },
];

const STRATEGIES_VIDEOS = [
  { title: "Introduction to Payment Recovery - Strategy 1", url: "https://youtu.be/cyPVlGz_5gY" },
  { title: "Strategy 2 - Recovery Uncle Strategy", url: "https://youtu.be/yUI4yk_miXA" },
  { title: "MSME Recovery Notice - Strategy 3", url: "https://youtu.be/cusbkJmS34E" },
  { title: "Local Market Association - Strategy 4", url: "https://youtu.be/EUq3-eGVRxc" },
  { title: "IVR Automated Calls - Strategy 5", url: "https://youtu.be/qusvgPFAlq4" },
  { title: "CNC (Call - Notice - Call) Process of Recovery - Strategy 6", url: "https://youtu.be/6Ob8R3tnNII" },
  { title: "Labour Union Dharna Strategy 7", url: "https://youtu.be/guBqnf0xCJE" },
  { title: "Strategy 8 – Money Recovery Agencies", url: "https://youtu.be/V2U99OhuzH0" },
  { title: "Strategy 9 - Debt Expert - MSME Consultant", url: "https://youtu.be/xvj9Ch2U8_w" },
  { title: "Strategy 10 - Cheque Bounce Recovery Strategy", url: "https://youtu.be/_GDV3jYl7QY" },
  { title: "Strategy 11 - Legal Recovery Suit Formula", url: "https://youtu.be/ag5WGd2RSOQ" },
  { title: "Market Repute Strategy", url: "https://youtu.be/_Lvfqlsctqw" },
  { title: "Reputation Exposure Method Strategy", url: "https://youtu.be/3Cq538ESONY" },
  { title: "GST Blacklist Defaulter Strategy", url: "https://youtu.be/fHXWvaiE8_8" },
  { title: "10 Page Legal Notice Thru Advocate", url: "https://youtu.be/g0I1InKOzSI" },
  { title: "Social Media Exposure", url: "https://youtu.be/l8xlmJ0cOHc" },
  { title: "5-Step Recovery Process of Kachha Payments", url: "https://youtu.be/QewcsP80n7g" },
  { title: "Recovery Aunty At Home at 7am", url: "https://youtu.be/mblRHAgNans" },
];

function getEmbedUrl(youtubeUrl) {
  const id = youtubeUrl.split('/').pop().split('?')[0];
  return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&autoplay=1`;
}

function VideoPlayer() {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') === 'strategies' ? 'strategies' : 'apc');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);

  // For demo: set hasPremium = true to unlock 11 Strategies
  // In production this would come from payment data
  const hasPremium = true;

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const videos = activeTab === 'apc' ? APC_VIDEOS : STRATEGIES_VIDEOS;
  const currentVideo = videos[selectedIndex];

  const handleTabSwitch = (tab) => {
    if (tab === 'strategies' && !hasPremium) return;
    setActiveTab(tab);
    setSelectedIndex(0);
  };

  return (
    <div className="min-h-screen bg-gray-950 flex flex-col">
      <NavbarSection isScrolled={isScrolled} />

      {/* Top Bar */}
      <div className="bg-gray-900 border-b border-gray-800 px-4 py-3 flex items-center gap-4 mt-16">
        <Link to="/course" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm">
          <FaArrowLeft /> Back to Course
        </Link>
        <span className="text-gray-600">|</span>
        <span className="text-white font-semibold text-sm truncate">{currentVideo.title}</span>
      </div>

      {/* Course Tabs */}
      <div className="bg-gray-900 border-b border-gray-800 px-4">
        <div className="flex gap-1 max-w-6xl mx-auto">
          <button
            onClick={() => handleTabSwitch('apc')}
            className={`flex items-center gap-2 px-5 py-3 text-sm font-semibold border-b-2 transition-all ${
              activeTab === 'apc'
                ? 'border-purple-500 text-purple-400'
                : 'border-transparent text-gray-400 hover:text-white'
            }`}
          >
            <BsCollectionPlayFill />
            Advance Payment Collection
            <span className="bg-purple-900 text-purple-300 text-xs px-2 py-0.5 rounded-full">{APC_VIDEOS.length}</span>
          </button>

          <button
            onClick={() => handleTabSwitch('strategies')}
            className={`flex items-center gap-2 px-5 py-3 text-sm font-semibold border-b-2 transition-all ${
              activeTab === 'strategies'
                ? 'border-emerald-500 text-emerald-400'
                : 'border-transparent text-gray-400 hover:text-white'
            } ${!hasPremium ? 'opacity-60 cursor-not-allowed' : ''}`}
          >
            <HiSparkles />
            11 Strategies
            <span className="bg-emerald-900 text-emerald-300 text-xs px-2 py-0.5 rounded-full">{STRATEGIES_VIDEOS.length}</span>
            {!hasPremium && <FaLock className="text-amber-400 text-xs" />}
          </button>
        </div>
      </div>

      {/* Main Layout */}
      <div className="flex flex-1 overflow-hidden" style={{ height: 'calc(100vh - 130px)' }}>

        {/* Sidebar - Chapter List */}
        <div className={`${sidebarOpen ? 'w-80' : 'w-0'} flex-shrink-0 bg-gray-900 border-r border-gray-800 overflow-y-auto transition-all duration-300`}>
          <div className="p-3">
            <div className="flex items-center justify-between mb-3 px-1">
              <span className="text-gray-400 text-xs font-semibold uppercase tracking-wider">
                {videos.length} Videos
              </span>
              <span className="text-gray-500 text-xs">
                {selectedIndex + 1} / {videos.length}
              </span>
            </div>

            {videos.map((video, idx) => (
              <button
                key={idx}
                onClick={() => setSelectedIndex(idx)}
                className={`w-full text-left px-3 py-3 rounded-lg mb-1 flex items-start gap-3 transition-all group ${
                  idx === selectedIndex
                    ? activeTab === 'apc'
                      ? 'bg-purple-900/60 border border-purple-700/50'
                      : 'bg-emerald-900/60 border border-emerald-700/50'
                    : 'hover:bg-gray-800 border border-transparent'
                }`}
              >
                <div className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold mt-0.5 ${
                  idx === selectedIndex
                    ? activeTab === 'apc' ? 'bg-purple-500 text-white' : 'bg-emerald-500 text-white'
                    : 'bg-gray-700 text-gray-400 group-hover:bg-gray-600'
                }`}>
                  {idx === selectedIndex ? <FaPlay className="text-xs" /> : idx + 1}
                </div>
                <span className={`text-sm leading-snug ${
                  idx === selectedIndex ? 'text-white font-medium' : 'text-gray-400 group-hover:text-gray-200'
                }`}>
                  {video.title}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Video Panel */}
        <div className="flex-1 flex flex-col bg-black overflow-auto">
          {/* Toggle Sidebar Button */}
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="absolute left-0 top-1/2 z-10 bg-gray-800 hover:bg-gray-700 text-gray-300 p-2 rounded-r-lg transition-all"
            style={{ marginTop: '130px' }}
          >
            <FaList className="text-xs" />
          </button>

          {/* YouTube Embed */}
          <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
            <iframe
              key={`${activeTab}-${selectedIndex}`}
              src={getEmbedUrl(currentVideo.url)}
              title={currentVideo.title}
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>

          {/* Video Info */}
          <div className="p-6 bg-gray-950">
            <div className="max-w-4xl">
              <div className="flex items-center gap-2 mb-2">
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${
                  activeTab === 'apc'
                    ? 'bg-purple-900 text-purple-300'
                    : 'bg-emerald-900 text-emerald-300'
                }`}>
                  {activeTab === 'apc' ? 'Advance Payment Collection' : '11 Strategies'}
                </span>
                <span className="text-gray-600 text-xs">Video {selectedIndex + 1} of {videos.length}</span>
              </div>
              <h2 className="text-white text-xl font-bold mb-4">{currentVideo.title}</h2>

              {/* Navigation Buttons */}
              <div className="flex gap-3">
                <button
                  onClick={() => setSelectedIndex(i => Math.max(0, i - 1))}
                  disabled={selectedIndex === 0}
                  className="px-4 py-2 bg-gray-800 hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm rounded-lg transition-all"
                >
                  ← Previous
                </button>
                <button
                  onClick={() => setSelectedIndex(i => Math.min(videos.length - 1, i + 1))}
                  disabled={selectedIndex === videos.length - 1}
                  className={`px-4 py-2 text-white text-sm rounded-lg transition-all disabled:opacity-40 disabled:cursor-not-allowed ${
                    activeTab === 'apc'
                      ? 'bg-purple-600 hover:bg-purple-500'
                      : 'bg-emerald-600 hover:bg-emerald-500'
                  }`}
                >
                  Next →
                </button>
              </div>
            </div>
          </div>

          {/* Locked State for Strategies */}
          {!hasPremium && activeTab === 'strategies' && (
            <div className="absolute inset-0 bg-gray-950/95 flex flex-col items-center justify-center z-20">
              <FaLock className="text-5xl text-amber-400 mb-4" />
              <h3 className="text-white text-2xl font-bold mb-2">Premium Content Locked</h3>
              <p className="text-gray-400 mb-6 text-center max-w-sm">
                Upgrade to unlock 11 Advanced Strategies for only ₹450 more.
              </p>
              <Link to="/course" className="bg-amber-500 hover:bg-amber-400 text-black font-bold px-8 py-3 rounded-xl transition-all">
                Upgrade Now
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default VideoPlayer;
